import { amountDisplay, capitalize, uppercase } from '@gameday/common/formats'
import { Icon } from '@gameday/react-components/components'
import styled from 'styled-components'

import theme, { rem } from '../../utils/theme'

const StyledCustomerPlan = styled.div`
  width: 100%;
  max-width: 650px;
  display: flex;
  padding: ${rem(20)};
  border: ${theme.borders.default};
  border-radius: ${rem(8)};

  & > .column {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    &.left {
      align-items: flex-start;

      & > h2 {
        margin: 0 0 ${rem(4)};
      }
    }

    &.right {
      align-items: flex-end;
      font-weight: ${theme.typography.fontWeightBolder};

      & > .price {
        font-size: ${theme.typography.fontSizeLg};
        margin-bottom: ${rem(-10)};
      }

      & > .price-per {
        font-size: ${theme.typography.fontSizeBase};
      }
    }
  }
`

const StyledChip = styled.span`
  display: inline-flex;
  align-items: center;
  height: ${rem(24)};
  padding: 0 ${rem(14)} 0 ${rem(4)};
  font-size: ${theme.typography.fontSizeTinyish};
  font-weight: ${theme.typography.fontWeightBold};
  color: ${theme.colors.white};
  border-radius: ${rem(2)};

  & + & {
    margin-left: ${rem(12)};
  }

  &.blue {
    background-color: ${theme.colors.lightBlue};
  }

  &.green {
    background-color: ${theme.colors.green};
  }

  & > .custom-icon {
    margin-right: ${rem(6)};
  }
`

export const CustomerPlan = props => {
  const { customerPlanName, paymentFrequency, price, currencyCode } = props

  return (
    <StyledCustomerPlan>
      <div className="column left">
        <h2>{customerPlanName}</h2>
        <div>
          <StyledChip className="blue">
            <Icon className="icon" iconSize={22} iconName="calender-alt" />
            {capitalize(paymentFrequency)}
          </StyledChip>
          <StyledChip className="green">
            <Icon className="icon" iconSize={22} iconName="currency" />
            {uppercase(currencyCode)}
          </StyledChip>
        </div>
      </div>
      <div className="column right">
        <div className="price">{amountDisplay(price || 0, currencyCode, false)}</div>
        <div className="price-per">/ month</div>
      </div>
    </StyledCustomerPlan>
  )
}

export default CustomerPlan
